// extracted by mini-css-extract-plugin
export default {"custom_text_div":"CustomText_custom_text_div__7eREg","custom_text_title":"CustomText_custom_text_title__jVu54","custom_text_value":"CustomText_custom_text_value__RB6TB"};